export const SOCIETES = {
  liste: 'Liste des sociétés',
  code: 'Code',
  libelle: 'Libellé',
  type: 'Type',
  typesSocietes: 'Types de sociétés',
  adresse: 'Adresse',
  tel: 'Téléphone',
  societesArchives: 'Afficher les sociétés archivées',
  create: 'Créer une société',
  signatureEmail: 'Signature e-mail',
  titreModifier: 'Modifier société {nom}',
  createAgence: 'Créer une agence',
  listeAgence: 'Liste des agences',
  modifier: 'Modifier',
  societe: 'Société',
  holding: 'Holding',
  annuler: 'Annuler',
  infoSociete: 'Informations de la société',
  codeSociete: 'Code société',
  typeSociete: 'Type société',
  email: 'Email principal',
  fax: 'Fax',
  codeAPE: 'Code APE',
  numeroEmetteur: 'Numéro émetteur SEPA',
  siret: 'Numéro de SIRET',
  juridique: 'Structure juridique',
  tva: 'TVA intra-communautaire',
  commentaireFactureIntracommunautaire: 'Commentaire Facture Intracommunautaire',
  regimeTva: 'Régime de Tva par défaut',
  tribunal: 'Tribunal',
  adresseLivraison: 'Adresse de livraison',
  adresseSociete: 'Adresse de la société',
  adressePost: 'Adresse postale',
  infoComp: 'Informations complémentaires',
  enregistrer: 'Enregistrer',
  agence: 'Agence',
  messages: {
    modifSuccess: 'Modification de la société réalisée avec succès',
  },
  produitDefaut: 'Produit de la société par défaut',
  errors: {
    codeSociete: 'Le code société doit être renseigné et avoir une longueur comprise entre 1 à 5 caractères',
    libelle: 'Le libellé doit être renseigné',
    adresse: 'L\'adresse doit être renseigné',
    shouldHaveAgence: 'La société doit contenir au moins une agence',
    unSeulTypeDeSequenceParMasque: 'Erreur sur le masque {champMasque} : un masque ne peut contenir une partie variable numérique et une alphabétique. Une seule est autorisée',
    produitReglementTlpe: 'Le produit règlement TLPE doit être un produit Location achat ou divers achat',
    regimeTva: 'Ce régime de TVA n\'existe pas pour cette société',
    produitLaisserEnPlace: 'Le produit Laisser en place doit être un produit divers achat',
    nomFichierExportSpe: 'Nom du fichier de génération spécifique',
    delaiLivraisonVisuel: 'Délai de livraison visuel',
    delaiLivraisonAfficheImprimee: 'Délai de livraison affiche imprimée pour Lc',
    delaiLivraisonAffichePreparee: 'Délai de livraison visuel affiche préparée',
    delaiLivraisonVisuelLc: 'Délai de livraison visuel pour Lc',
    delaiLivraisonAfficheImprimeeLc: 'Délai de livraison affiche imprimée pour Lc',
    delaiLivraisonAffichePrepareeLc: 'Délai de livraison visuel affiche préparée pour Lc',
    delaiLivraisonVisuelRxLc: 'Délai de livraison visuel pour réseau Lc',
    delaiLivraisonAfficheImprimeeRxLc: 'Délai de livraison affiche imprimée pour réseau Lc',
    delaiLivraisonAffichePrepareeRxLc: 'Délai de livraison visuel affiche préparée pour réseau Lc',
    delaiLivraisonVisuelRxMairie: 'Délai de livraison visuel pour réseau mairie',
    delaiLivraisonAfficheImprimeeRxMairie: 'Délai de livraison affiche imprimée pour réseau mairie',
    delaiLivraisonAffichePrepareeRxMairie: 'Délai de livraison visuel affiche préparée pour réseau mairie',
    tauxMaintenance: 'Le taux de maintenance',
  },
  codeGeneratorBail: {
    title: 'Paramétrage code bail',
    code: 'Code bail',
    paramCodeBail: {
      agence: 'Code agence',
      sequence: 'Séquence',
    },
  },
  codeGeneratorCompteComptable: {
    title: 'Paramétrage compte comptable',
    paramCompteComptable: {
      sequence: 'Séquence',
    },
  },
  codeGeneratorFacture: {
    title: 'Paramétrage code facture',
    code: 'Code facture',
    paramFacture: {
      annee: 'Deux derniers caractères de l\'année',
      anneefull: 'L\'année complète',
      mois: 'Mois',
      nomComptable: 'Nom comptable',
      codeSocietefull: 'Code société complet',
      codeSociete: 'Dernier caractère du code société',
      codeSocieteExtended: 'Deux derniers caractères du code société',
      codeRegle: 'Trois premiers caractères du code règle de facturation',
      codeRegleExtended: 'Cinq premiers caractères du code règle de facturation',
      codeRegleFull: 'Code règle de facturation complet',
      exercice: 'Deux derniers caractères du code d\'exercice comptable',
      exerciceExtended: 'Quatre derniers caractères du code d\'exercice comptable',
      codeAgence: 'Dernier caractère du code de l\'agence',
      codeAgenceExtended: 'Deux derniers caractères du code de l\'agence',
      libelleAgence: 'Dernier caractère du nom de l\'agence',
      libelleAgenceExtended: 'Deux derniers caractères du nom de l\'agence',
      sequence: 'Séquence',
      suffixeCodeFacture: 'Suffixe paramétré dans l\'agence',
    },
    warningMessage: {
      title: 'Attention',
      content: 'Tout changement de code facture alors que des factures existent déjà peut avoir des effets de bords. Merci de contacter l\'assistance pour confirmation',
    },
  },
  codeGeneratorEmplacement: {
    title: 'Paramétrage code emplacement',
    code: 'Code emplacement',
    paramCodeEmplacement: {
      insee: 'Code insee',
      codePostal: 'Code postal',
      sequence: 'Séquence',
      sequenceAlpha: 'Séquence alphabétique',
    },
  },
  codeGeneratorParution: {
    title: 'Paramétrage code parution',
    code: 'Code parution',
    paramCodeParution: {
      libelleProduit: 'Libellé du produit',
      referenceProduit: 'Référence produit',
      nom: 'Nom de la parution',
      num: 'Numéro de la parution',
    },
  },
  codeGeneratorDispositif: {
    title: 'Paramétrage code dispositif',
    code: 'Code dispositif',
    paramCodeDispositif: {
      codeEmplacement: 'Code emplacement',
      insee: 'Code insee',
      codePostal: 'Code postal',
      codificationDispositif: 'Codification dispositif',
      sequence: 'Séquence',
      sequenceAlpha: 'Séquence alphabétique',
    },
  },
  codeGeneratorMateriel: {
    title: 'Paramétrage code matériel',
    code: 'Code matériel',
    paramCodeMateriel: {
      codeDispositif: 'Code dispositif',
      visibilite: 'Visibilité (première lettre uniquement)',
      disposition: 'Disposition',
      sequence: 'Séquence',
      sequenceAlpha: 'Séquence alphabétique',
    },
  },
  codeGeneratorFace: {
    title: 'Paramétrage code face',
    code: 'Code face',
    paramCodeFace: {
      codeMateriel: 'Code matériel',
      sequence: 'Séquence',
      sequenceAlpha: 'Séquence alphabétique',
    },
  },
  libelleGeneratorProduit: {
    title: 'Paramétrage libellé produit',
    paramLibelleProduit: {
      reference: 'Référence produit',
      materiel: 'Matériel produit',
      format: 'Format produit',
      adresse: 'Adresse produit',
      confrereCom: 'Nom commercial confrère',
      confrereJur: 'Nom juridique confrère',
      adresseComplete: 'Adresse complète produit',
    },
  },
  masqueBloc: {
    title: 'Code / Libellé configuration',
    titleCompta: 'Compte comptable configuration',
    masqueCodeFacture: 'Code facture',
    masqueCodeBail: 'Code bail',
    masqueCompteComptableClient: 'Compte comptable client',
    masqueCompteComptableBailleur: 'Compte comptable bailleur',
    masqueCodeEmplacement: 'Code emplacement',
    masqueCodeDispositif: 'Code dispositif',
    masqueCodeMateriel: 'Code matériel',
    masqueCodeFace: 'Code face',
    masqueCodeParution: 'Code parution',
    masqueLibelleProduitUnitairePatrimonial: 'Libellé produit face patrimoniale',
    masqueLibelleProduitUnitaireNonPatrimonial: 'Libellé produit face non patrimoniale',
    masqueLibelleProduitEcranNumeriquePatrimonial: 'Libellé produit écran num. patrimonial',
    masqueLibelleProduitEcranNumeriqueNonPatrimonial: 'Libellé produit écran num. non patrimonial',
    nomComptable: 'Nom comptable',
  },
  tab: {
    societe: 'Société',
    comptabilite: 'Comptabilité',
    fonctionnement: 'Fonctionnement',
    logistique: 'Logistique',
    edition: 'Edition',
    configVenteInterne: 'Refacturation interne',
    journaux: 'Journaux',
    centralisation: 'Comptes de centralisation',
    acomptes: 'Acomptes',
    gestionCourante: 'Comptes de gestion courante',
    divers: 'Divers',
    export: 'Export',
    stock: 'Stock',
    produitStockParDefaut: 'Produits stock par défaut',
    produitVente: 'Produit vente',
    produitAchat: 'Produit achat',
    mentionsLegales: 'Mentions légales',
    signatureElectronique: 'Signature électronique',
    infosGeneral: 'Informations générale',
    logistiqueImpression: 'Logistique impression',
  },
  produitLocDefaut: {
    info: 'Permettra, lors de la création / modification d\'un devis, commande, facture et lors de l\'utilisation du planning, de mettre le produit de location sélectionné dans la recherche',
    produitLocationDefaut: 'Produit location par défaut',
    title: 'Produit location par défaut',
    unitaire: 'Face unitaire',
    regroupement: 'Réseau temporaire',
    regroupementNumerique: 'Réseau numérique',
    regroupementLc: 'Réseau LC',
    ecranNumerique: 'Ecran numérique',
  },
  produitAssocieLocDefaut: {
    info: 'Permettra, lors de la création d\'un produit (face, écran numérique, réseau temporaire, réseau LC, réseau numérique) de créer directement un produit associé à la date du jour avec la location sélectionnée ici',
    title: 'Produit location associé par défaut',
    unitaire: 'Face unitaire',
    regroupement: 'Réseau temporaire',
    regroupementNumerique: 'Réseau numérique',
    regroupementLc: 'Réseau LC',
    ecranNumerique: 'Ecran numérique',
  },
  produitAchat: {
    title: 'Produits d\'achats',
    affichage: 'Produit d\'affichage',
    grattage: 'Produit de grattage',
    loyer: 'Produit de loyer',
    otTech: 'Produit d\'OT technique',
    reglementTlpe: 'Produit de règlement TLPE :',
    produitAchatCommission: 'Produit de commission :',
    laisserEnPlace: 'Produit de laisser en place :',
  },
  produitDiversDefaut: {
    title: 'Produit divers par défaut',
    tlpe: 'TLPE par défaut',
    fraisTechnique: 'Frais technique par défaut',
    honoraire: 'Honoraire par défaut',
    pose: 'Pose par défaut',
    produitAnnulation: 'Annulation de règlement',
  },
  journalOd: 'Journal opération diverse',
  journalVente: 'Journal de vente',
  journalAchat: 'Journal d’achat',
  signatureToken: 'Token',
  signatureReference: 'Reference externe',
  compteCentralisationClient: 'Compte de centralisation client',
  compteCentralisationFournisseur: 'Compte de centralisation fournisseur',
  schemaComptableFacturation: 'Schéma comptable de facturation d\'acompte',
  schemaComptableExtourne: 'Schéma comptable d\'extourne d\'acompte',
  refSocInter: 'Référence société',
  tokenExtCompta: 'Token d’export',
  exportOdComptabiliteDefaut: 'Exporter les OD en comptabilité',
  exportComptaSpe: 'Génération spécifique',
  nomFichierExportSpe: 'Nom du fichier de génération spécifique',
  tvaSurDebit: 'Option pour le paiement de la taxe d\'après les débits',
  nomFichierExportLot: 'Nom fichier export',
  tailleLogoY: 'Taille du logo en hauteur (px)',
  tailleLogoX: 'Taille du logo en largeur (px)',
  parametrageEdition: 'Paramètres édition',
  compteChargeGestionCourante: 'Compte de charge',
  compteProduitGestionCourante: 'Compte de produit',
  typeOtAudit: 'Type OT audit par défaut',
  typeOtImpression: 'Type OT impression par défaut',
  fonctionnement: {
    poseOption: {
      title: 'Pose d\'option avec validation',
      titleBlocage: 'Modification de blocage avec validation',
      tous: 'Tous',
      utilisateurAValider: 'Utilisateurs à valider',
      utilisateur: 'Utilisateurs à prévenir',
      info: 'Définissez les commerciaux qui devront obtenir la validation des administrateurs pour valider leurs poses d’option',
      infoBlocage: 'Définissez les commerciaux qui devront obtenir la validation des administrateurs pour modifier leurs blocages',
    },
    yield: {
      title: 'Yield',
      decideurCommercial: 'Décideurs commerciaux',
      utilisateursNonControles: 'Utilisateurs non contrôlés',
    },
    utilisateurEcheanceNegativeVente: {
      title: 'Echéance négative sur commande de vente',
      authorizedUsers: 'Utilisateurs autorisés',
    },
  },
  fonctionnalitesFacultatives: {
    title: 'Fonctionnalités facultatives',
    baf: 'Gestion du bon à facturer',
    valeurDefaut: 'Valeur par défaut du bon à facturer',
  },
  venteInterne: {
    title: 'Configuration vente interne',
    activation: 'Activation',
    recopieRemise: 'Recopie des remises',
    pourcentage: '% refacturation',
    agence: 'Agence commande vente interne',
    tiers: 'Correspondence société/tiers',
    tabTiers: {
      societe: 'Société',
      fournisseur: 'Fournisseur',
      client: 'Client',
      modeReglement: 'Mode de règlement',
      delaiReglement: 'Délai de règlement',
    },
  },
  texteEdition: {
    editionUnitaire: {
      title: 'Textes d\'édition face unitaire',
      devis: 'Texte devis face unitaire',
      commande: 'Texte commande face unitaire',
      facture: 'Texte facture face unitaire',
    },
    editionDefaut: {
      title: 'Textes d\'édition par défaut',
      devis: 'Texte devis par défaut',
      commande: 'Texte commande par défaut',
      facture: 'Texte facture par défaut',
    },
    texteEditionSignature: {
      title: 'Textes inserés dans l\'encadré de signature',
      devis: 'Texte devis',
      commande: 'Texte commande',
      isTextEditionSignatureUnderCard: 'Mettre le texte en dessous du carré de signature',
    },
    texteEditionTlpe: {
      title: 'Texte inseré dans le courrier d\'accompagnement déclaration TLPE',
      texteEditionCourrierTlpe: 'Texte Edition Courrier Tlpe ',
    },
    texteInfoBancaire: {
      title: 'Information Bancaire',
      texteEditionInfoPaiement: 'Information Paiement',
    },
  },
  mentionsLegales: {
    title: 'Mentions légales',
    retardPaiement: 'Retard paiement',
  },
  signatureElectronique: {
    title: 'Signature électronique',
  },
  destinataireComptable: {
    destinataireComptable: 'Détermination du destinataire comptable',
    destinataire: 'Destinataire',
    payeur: 'Payeur',
    premierAnnonceur: 'Premier annonceur',
    premierDonneurOrdre: 'Premier donneur d\'ordre',
  },
  role: {
    regie: 'Régie',
    mandatairePayeur: 'Mandataire payeur',
    mandataireNonPayeur: 'Mandataire non payeur',
    sousMandataire: 'Sous mandataire',
  },
  signataire: {
    title: 'Signataires',
  },
  delaiAdministratif: {
    title: 'Délai administratif',
    vente: 'Nb jours pour les ventes',
    achat: 'Nb jours pour les achats',
  },
  messageInfo: 'Vous pouvez ajouter/supprimer autant de "X" que vous voulez. ',
  client: {
    settlementMode: 'Mode de règlement',
    settlementPeriod: 'Délai de règlement',
    factureParMail: 'Le client souhaite recevoir ses factures par mail',
    defaultValueClient: 'Informations par défaut des clients',
    lieuStockageDefault: 'Lieu de stockage',
  },
  regleFacturation: {
    title: 'Règle de facturation',
  },
  indexationCommande: {
    title: 'Indexation commande',
    categorieProduit: 'Catégorie produit',
    mantisse: 'Mantisse',
  },
  logistiqueImpression: {
    tauxMaintenance: 'Taux de maintenance',
    typeProduit: 'Type de produit',
    affichageTo: 'Pour un affichage en TO',
    libelleVisuel: 'Le visuel doit être livré',
    libelleAfficheImprimee: 'Les affiches imprimées doivent être livrées',
    libelleAffichePreparee: 'Les affiches préparées doivent être livrées',
    infoDelai: 'jour(s) avant',
    produit: {
      lc: 'LC',
      reseauTempo: 'Réseau tempo',
      reseauLc: 'Réseau LC',
      reseauMairie: 'Réseau mairie',
    },
    produitDefaut: {
      title: ' Produits d\'achat d\'impression par défaut',
      visuel: 'Visuel',
      impression: 'Impression',
      faconnage: 'Façonnage',
      impressionEtFaconnage: 'Impression et façonnage',
    },
  },
};

export const DETAIL = {
  title: 'Détail de {libelle}',
  infoGeneral: 'Informations générales',
  listeAgences: 'Liste des agences',
  infoCompta: 'Comptabilité',
  parametrageEdition: 'Paramètres édition',
  textEdition: 'Textes d\'édition',
  buttons: {
    back: 'Retour',
    edit: 'Modifier',
    fusion: 'Fusion de société',
  },
  steps: {
    generalInfos: 'Informations générales',
    listeAgences: 'Liste des agences',
    piecesJointes: 'Pièces jointes',
    parametresEdition: 'Paramètres édition',
    produitLoc: 'Produit location par défaut',
    produitAssocieLoc: 'Produit location associé par défaut',
    textEdition: 'Textes d\'édition',
    produitAchat: 'Produits d\'achats',
    poseOption: 'Pose d\'option avec validation',
    blocage: 'Modification de blocage avec validation',
    produitDivers: 'Produit divers par défaut',
    fonctionnaliteFacultative: 'Fonctionnalités facultatives',
    signataire: 'Signataires',
    masque: 'Code / Libellé configuration',
    delaiAdministratif: 'Délai administratif',
    infoCompta: 'Comptabilité',
    infoClient: 'Informations par défaut des clients',
    infoRegleFacturation: 'Règle de facturation',
    yield: 'Yield',
    logistique: 'Logistique',
    indexationCommande: 'Indexation commande',
    produitStock: 'Produits stock par défaut',
    echeancesNegativesVente: 'Echéance négative sur commande de vente',
  },
  infoSociete: {
    codeSociete: 'N° {code}',
    coordonnees: 'Coordonnées',
    infoAdministratives: 'Infos administratives',
    adresse: 'Adresse',
    adresseDetail: 'Adresse : ',
    telephone: 'Téléphone :',
    siret: 'Siret :',
    ape: 'APE :',
    numeroEmetteur: 'Numéro émetteur SEPA :',
    tvaIntracommunautaire: 'TVA intracommunautaire :',
    regimeTva: 'Régime de TVA par défaut :',
    commentaireFactureIntracommunautaire: 'Commentaire Facture Intracommunautaire :',
    structureJuridique: 'Structure juridique :',
    tribunal: 'Tribunal :',
    adresseLivraison: 'Adresse de livraison :',
    journalOd: 'Journal opération diverse',
    journalVente: 'Journal de vente',
    journalAchat: 'Journal d’achat',
    compteCentralisationClient: 'Compte de centralisation client',
    destinataireComptable: 'Détermination du destinataire comptable',
    compteCentralisationFournisseur: 'Compte de centralisation fournisseur',
    schemaComptableFacturation: 'Schéma comptable de facturation d\'acompte',
    schemaComptableExtourne: 'Schéma comptable d\'extourne d\'acompte',
    refSocInter: 'Référence société',
    tokenExtCompta: 'Token d’export :',
    exportOdComptabiliteDefaut: 'Exporter les OD en comptabilité :',
    nomFichierExportLot: 'Nom fichier export :',
    tailleLogoY: 'Taille du logo en hauteur (px) :',
    tailleLogoX: 'Taille du logo en largeur (px) :',
    textDevis: 'Texte devis face unitaire :',
    textCommande: 'Texte commande face unitaire :',
    textFacture: 'Texte facture face unitaire :',
    textDevisDefaut: 'Texte devis par défaut :',
    textCommandeDefaut: 'Texte commande par défaut :',
    textFactureDefaut: 'Texte facture par défaut :',
    compteChargeGestionCourante: 'Compte de charge gestion courante :',
    compteProduitGestionCourante: 'Compte de produit gestion courante :',
    tvaSurDebit: 'Option pour le paiement de la taxe d\'après les débits :',
    texteEditionCourrierTlpe: 'Texte courrier Tlpe :',
    exportComptaSpe: 'Génération spécifique',
    nomFichierExportSpe: 'Nom du fichier de génération spécifique',
    signatureElectroniqueToken: 'Token :',
    signatureElectroniqueReference: 'Reference externe :',
    tauxMaintenance: 'Taux de maintenance :',
  },
  masqueBloc: {
    title: 'Code / Libellé configuration',
    titleCompta: 'Compte comptable configuration',
    masqueCodeFacture: 'Code facture :',
    masqueCodeBail: 'Code bail :',
    masqueCompteComptableClient: 'Compte comptable client',
    masqueCompteComptableBailleur: 'Compte comptable bailleur',
    masqueCodeEmplacement: 'Code emplacement',
    masqueCodeDispositif: 'Code dispositif',
    masqueCodeMateriel: 'Code matériel',
    masqueCodeFace: 'Code face',
    masqueCodeParution: 'Code parution',
    masqueLibelleUnitairePatrimonial: 'Libellé produit face patrimonial :',
    masqueLibelleUnitaireNonPatrimonial: 'Libellé produit face non patrimonial :',
    masqueLibelleEcranNumPatrimonial: 'Libellé produit écran num. patrimonial :',
    masqueLibelleEcranNumNonPatrimonial: 'Libellé produit écran num. non patrimonial :',
    nomComptable: 'Nom comptable',
  },
  produitLocDefaut: {
    title: 'Produit location par défaut',
    info: 'Permettra, lors de la création / modification d\'un devis, commande, facture et lors de l\'utilisation du planning, de mettre le produit de location sélectionné dans la recherche',
    unitaire: 'Face unitaire :',
    regroupement: 'Réseau temporaire :',
    regroupementNumerique: 'Réseau numérique :',
    ecranNumerique: 'Ecran numérique :',
    regroupementLc: 'Réseau LC :',
  },
  produitAssocieLocDefaut: {
    title: 'Produit location associé par défaut',
    info: 'Permettra, lors de la création d\'un produit (face, écran numérique, réseau temporaire, réseau LC, réseau numérique) de créer directement un produit associé à la date du jour avec la location sélectionnée ici',
    unitaire: 'Face unitaire :',
    regroupement: 'Réseau temporaire :',
    regroupementNumerique: 'Réseau numérique :',
    regroupementLc: 'Réseau LC :',
    ecranNumerique: 'Ecran numérique :',
  },
  produitAchat: {
    title: 'Produits d\'achats',
    affichage: 'Produit d\'affichage :',
    grattage: 'Produit de grattage :',
    loyer: 'Produit de loyer :',
    otTech: 'Produit d\'OT technique :',
    reglementTlpe: 'Produit de règlement TLPE :',
    produitAchatCommission: 'Produit de commission :',
    laisserEnPlace: 'Produit de laisser en place :',
  },
  produitDiversDefaut: {
    title: 'Produit divers par défaut :',
    tlpe: 'TLPE par défaut :',
    fraisTechnique: 'Frais technique par défaut :',
    honoraire: 'Honoraire par défaut :',
    pose: 'Pose par défaut :',
    produitAnnulation: 'Annulation de règlement :',
  },
  poseOption: {
    title: 'Pose d\'option avec validation',
    titleBlocage: 'Modification de blocage avec validation',
    tous: 'Tous',
    utilisateurAValider: 'Utilisateurs à valider:',
    utilisateur: 'Utilisateurs à prévenir :',
  },
  fonctionnalitesFacultatives: {
    title: 'Fonctionnalités facultatives',
    baf: 'Gestion du bon à facturer :',
    valeurDefaut: 'Valeur par défaut du bon à facturer :',
  },
  signataire: {
    title: 'Signataires',
  },
  delaiAdministratif: {
    title: 'Délai administratif',
    vente: 'Nb jours pour les ventes :',
    achat: 'Nb jours pour les achats :',
  },
  libelleSocieteForLogo: 'Société {libelle}',
  yield: {
    title: 'Yield',
    decideurCommercial: 'Décideurs commerciaux :',
    utilisateursNonControles: 'Utilisateurs non contrôlés :',
  },
  logistique: {
    title: 'Logistique',
    typeOtAudit: 'Type OT audit par défaut :',
    typeOtImpression: 'Type OT impression par défaut :',
  },
  produitStockParDefaut: {
    title: 'Produit stock par défaut',
    produitVente: 'Produit vente :',
    produitAchat: 'Produit achat :',
  },
  fusionSociete: {
    title: 'Fusion de société',
    societeDestinataire: 'Société à conserver',
    societeOrigine: 'Société à fusionner',
    success: 'Fusion des sociétés effectuée avec succès',
    msgPrevention: 'Vous allez supprimer {societeOrigine} et le remplacer par {societeDestinataire} ?',
    adresse: 'Adresse',
    placeholder: 'Sélectionner une société',
    errors: {
      societeOrigineId: 'La société à fusionner',
      societeDestinataireId: 'La société à conserver',
      cannotBeMergedSameCompany: 'On ne peut fusionner la même société.',
      cannotHaveSameInvoiceCoding: 'Les deux sociétés à fusionner ne peuvent avoir la même codification des factures.',
      agencesNotSameSociete: 'Les agences à transférer ne sont pas de la même société.',
      societeMustHaveOnlyOneRegleFacturation: 'La société {societe} doit avoir qu\'une règle de facturaction.',
      societeStillHasAgncies: 'La société à fusionner a toujours des agences.',
      sameCompanyMergeError: 'Impossible de fusionner car vous êtes sur la société active.',
      mustHaveProduitAchatAffichageId: 'La société de destination doit avoir un produit achat affichage par défaut.',
      mustHaveProduitAchatGrattageId: 'La société de destination doit avoir un produit achat grattage par défaut.',
      mustHaveProduitAchatLaisserEnPlaceId: 'La société de destination doit avoir un produit achat laisser en place par défaut.',
    },
  },
  utilisateurEcheanceNegativeVente: {
    title: 'Echéance négative sur commande de vente',
    authorizedUsers: 'Utilisateurs autorisés :',
  },
  produitDefautImpressionAffiche: {
    visuel: 'Visuel :',
    impression: 'Impression :',
    faconnage: 'Façonnage :',
    impressionEtFaconnage: 'Impression et façonnage :',
  },
};
